import { Formik, Form, Field, useFormikContext } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL } from '../../utilities/constants';
import { handleApiCall, Label } from '../../utilities/helper';
import { useUI } from '../../context/UI';

const EditTemplatePage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [controller, setController] = useState(null);
    const [data, setData] = useState();
     const { id } = useParams();
    // const { values }= useFormikContext([]);
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();

    const [initialValues, setInitialValues] = useState({
        name: "",
        subject: "",
        body: "",

    });
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        body: Yup.string().required('Body is required'),
        subject: Yup.string().required('Subject is required'),

    });
    const maxWords = 150;

    const handleWordLimit = (e, form) => {
        const words = e.target.value.trim().split(/\s+/);
        if (words.length <= maxWords) {
            form.setFieldValue("body", e.target.value);
        }
    };

     const callListApi = async () => {
            controller?.abort();
            const newController = new AbortController();
            setController(newController);
            const { signal } = newController;
            setLoading(true);
            try {
                const response = await handleApiCall(
                    `${API_BASE_URL}/api/1.0.0/template/${id}`,
                    {
                        method: "GET"
                    },
                    null,
                    signal
                );
                if (response.responseStatus == true) {
                    setData(response.data);
                } else {
                    setData(null);
                }
                if (response.responseCode !== 299) {
                    setLoading(false);
                }
            } catch (e) {
                console.error("Error", e);
            } finally {
                setLoading(false);
            }
        };
        useEffect(() => {
            callListApi();
            setSegmentTitle("Template Details");
        }, []);

        
    useEffect(() => {
        setInitialValues({
            name: data?.name,
            subject: data?.subject,
            body: data?.body,

        })
    }, [data])

    const handleEditTemplatePage = async (value) => {
        setLoading(true);
        try {
            const payload = {
                name: value.name,
                subject: value.subject,
                body: value.body,


            };
            console.log("Payload before API call:", JSON.stringify(payload, null, 2));
            console.log('payload', payload)

            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/template/${id}`, {
                method: "PUT",
                body: payload,
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully updated a Template, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully updated a Template!",
                    status: true,
                    archive: false,
                });
                navigate(`/notification`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while creating a Template. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while creating a Template.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleEditTemplatePage}
            enableReinitialize={true}
        >
            {({ setFieldValue, values, errors, touched }) => {
                const maxWords = 150;
                const wordCount = values?.body
                    ? values.body.trim().split(/\s+/).length
                    : 0;

                return (
                    <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Template Name */}
                            <div>
                                <Label title="Template Name" />
                                <Field
                                    name="name"
                                    type="text"
                                    placeholder="Eg: Test Template"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.name && touched.name
                                            ? "border-red-500 focus:ring-red-300"
                                            : "border-gray-300 focus:ring-brand-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                        }`}
                                />
                                {errors.name && touched.name && (
                                    <p className="text-xs text-red-500 mt-1">{errors.name}</p>
                                )}
                            </div>

                            <div>
                                <Label title="Subject" />
                                <Field
                                    name="subject"
                                    type="text"
                                    placeholder="Eg: Exclusive new year offer"
                                    className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.subject && touched.subject
                                            ? "border-red-500 focus:ring-red-300"
                                            : "border-gray-300 focus:ring-brand-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                        }`}
                                />
                                {errors.subject && touched.subject && (
                                    <p className="text-xs text-red-500 mt-1">{errors.subject}</p>
                                )}
                            </div>

                            <div>
                                <Label title="Body" />
                                <Field
                                    as="textarea"
                                    name="body"
                                    placeholder="Eg: Exclusive new year offer"
                                    rows={4}
                                    onChange={(e) => {
                                        const words = e.target.value.trim().split(/\s+/);
                                        if (words.length <= maxWords) {
                                            setFieldValue("body", e.target.value);
                                        }
                                    }}
                                    className={`w-full px-3 py-2 border rounded-md text-sm resize-none focus:outline-none focus:ring ${errors.body && touched.body
                                            ? "border-red-500 focus:ring-red-300"
                                            : "border-gray-300 focus:ring-brand-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                        }`}
                                />
                                <div className="flex justify-between mt-1 text-xs text-gray-500 dark:text-gray-400">
                                    <span>
                                        {wordCount}/{maxWords} words
                                    </span>
                                    {errors.body && touched.body && (
                                        <span className="text-red-500">{errors.body}</span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-3 pt-4">
                            <NavLink to="/notification">
                                <button
                                    type="reset"
                                    className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                                >
                                    Cancel
                                </button>
                            </NavLink>
                            <button
                                type="submit"
                                className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default EditTemplatePage;


